import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { Typography } from 'ui-v2/components/Typography';
import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './CarShopListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import dynamic from 'next/dynamic';

const Swiper = dynamic(() => import('core-lib/components/Swiper'), {
  ssr: false,
});

const CarShopListing = ({ data, index }: LayoutPropType) => {
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.sectionName, {
        position: index,
      });
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);

  const handleClick = (e) => {
    handleItemClickWithDelegation(
      e,
      CARDID,
      data?.entityType,
      data?.data,
      data?.sectionName
    );
  };

  return (
    <div className={s.root} ref={rootRef} onClick={handleClick}>
      <Swiper
        swiperModules={['Pagination', 'AutoPlay']}
        speed={500}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={true}
        slidesPerView={1}
        slides={data?.data?.map((item, i) => (
          <div
            key={item?.productId}
            id={CARDID}
            data-index={i}
            className={s.overallContent}
          >
            <ShimmerImage
              src={item?.coverImage}
              className={s.image}
              loading="eager"
            />
            <div className={s.content}>
              <div className={s.carIcon}>
                <ShimmerImage
                  src={item?.brandLogo}
                  className={s.carIconImage}
                  loading="eager"
                  alt="icon"
                />
              </div>
              <div className={s.textContent}>
                <Typography
                  label={item?.subtitle1 || ' '}
                  variant="label_4_medium"
                  color="purple_tertiary"
                />
                <Typography
                  label={item?.title || ' '}
                  variant="h_4_bold"
                  color="purple_tertiary"
                />
              </div>
            </div>
          </div>
        ))}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
      />
    </div>
  );
};

export default CarShopListing;
